<template>
  <div>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <v-btn @click="newQueryHandler()" :disabled="disabled">
      <v-icon color="info" class="mr-2">add</v-icon>
      <div class="text-capitalize">{{ $t("Button.New") }}</div>
    </v-btn>
  </div>
</template>

<script>

  import {
    changesNotSavedParam,
  } from '@/helpers/multiStationQuery'

  export default {
    props: {
      disabled: Boolean,
      confirmOnNew: Boolean,
    },
    methods: {
      newQueryHandler() {
        if (this.confirmOnNew) this.confirmNewQuery()
        else this.newQuery()
      },
      async confirmNewQuery() {
        let confirm = await this.$refs.confirmationDialog.confirm(changesNotSavedParam)
        if (!confirm) return
        await this.newQuery()
      },
      newQuery() {
        this.$store.dispatch('multistation/clearMissingParams')
        this.$emit('clear:query')
      },
    },
  }
</script>